import CaseFirstViewItemWhite from 'components/cases/common/CaseFirstViewItemWhite/CaseFirstViewItemWhite'

export default CaseFirstViewItemWhite
